import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';

import { GetSpaceNameQuery, GetTemplateInfoQuery } from './queries/index.ts';
import type {
	GetSpaceNameQuery as GetSpaceNameQueryType,
	GetSpaceNameQueryVariables,
} from './queries/__types__/GetSpaceNameQuery.ts';
import type {
	GetTemplateInfoQuery as GetTemplateInfoQueryType,
	GetTemplateInfoQueryVariables,
} from './queries/__types__/GetTemplateInfoQuery.ts';

const _getSpaceNameQuery = async (
	variables: GetSpaceNameQueryVariables,
): Promise<GetSpaceNameQueryType> => {
	// eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
	return (
		await queryInterop<GetSpaceNameQueryType, GetSpaceNameQueryVariables>({
			query: GetSpaceNameQuery,
			variables,
		})
	).data;
};

const _getTemplateInfoQuery = async (
	variables: GetTemplateInfoQueryVariables,
): Promise<GetTemplateInfoQueryType> => {
	// eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
	return (
		await queryInterop<GetTemplateInfoQueryType, GetTemplateInfoQueryVariables>({
			query: GetTemplateInfoQuery,
			variables,
		})
	).data;
};

export const getSpaceName = async (spaceKey: string): Promise<any> => {
	const spaceNameData = await _getSpaceNameQuery({ spaceKey });
	return spaceNameData?.space?.name;
};

export const getTemplateInfo = async (id: any): Promise<any> => {
	const templateData = await _getTemplateInfoQuery({ id });
	return templateData?.templateInfo;
};
